import type { VerifyMfaBody } from "./auth.api";
import { api } from "@/services/api";

export interface ChangePasswordBody {
  old_password: string;
  new_password: string;
  mfa?: VerifyMfaBody;
}

export const userApi = {
  async changePassword(body: ChangePasswordBody): Promise<void> {
    await api.post("/user/change-password", body);
  },

  async removeAccount(): Promise<void> {
    await api.delete("/user");
  },

  async reactiveAccount(hash: string): Promise<void> {
    await api.post(`/user/reactivate-account`, { hash });
  },

  async sendReactivationLink(email: string): Promise<void> {
    await api.post(`/user/send-reactivation-link`, { email });
  },
};
